module.exports = __webpack_public_path__ + "img/31.84ffe7ef.png";